import React from 'react'
import { styled, SelectChangeEvent, Grid } from '@mui/material'
import { PageState } from '../../../containers/facilityDetailAvailability/facilityDetailAvailabilityService';
import { GContainer } from '../common/grids';
import { SelectNoBind } from '../common/inputs/selectNoBind';
import { AttentionLabel } from '../common/attentionLabel';
import { translate } from '../../../i18n';

const ChildSelectionGContainer = styled(GContainer)({
  marginBottom: '8px',
})

interface diagonosisSelectionProps {
  diagonosisDecodeMst: { value: string; label: string }[]
  changeDropDownSelectedDiagonosis: (event: SelectChangeEvent<string>) => void
  state: PageState
  name: string
}
const DiagonosisSelection: React.FC<diagonosisSelectionProps> = (
  { diagonosisDecodeMst, changeDropDownSelectedDiagonosis, name, state }
) => {
  const value = state.diagonosis[name as keyof typeof state.diagonosis];

  return (
    <ChildSelectionGContainer>
      <div>
        {translate(`facilityDetailAvailability.label.diagonosis.${name}`)}
        {
          name === 'first' && (
            <AttentionLabel>*</AttentionLabel>
          )
        }
      </div>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SelectNoBind
            fullWidth
            onChange={changeDropDownSelectedDiagonosis}
            valueLabels={diagonosisDecodeMst}
            value={value ?? undefined}
          />
        </Grid>
      </Grid>
    </ChildSelectionGContainer>
  )
}

export default DiagonosisSelection